/* eslint-disable default-case */

import CREDIT_EVENTS from "../utils/CreditEvents";
import { ProfileAttr, STORAGE_ITEMS } from "./constants";
import LogService from "./LogService";
import { StorageService } from "./StorageService";
import TEAM_DETAILS_EVENTS from "../utils/teamsEvents";
import TEAM_JOINING_EVENTS from "../utils/teamJoiningEvents";

import {
  ACTION_CANDIDATE_CALLED,
  ACTION_CANDIDATE_MESSAGED,
  ACTION_CANDIDATE_REJECT,
  ACTION_DEACTIVATE,
  ACTION_INVITE_FOR_INTERVIEW,
  ACTION_OPEN_RESUME,
  CALL_FEEDBACK_EVENTS,
  CANDIDATE_FEEDBACK_SUBMIT,
  CLOSE_JOB_CLICKED,
  CMP_AUDIO_COMPLETE,
  CMP_AUDIO_PLAYED,
  CMP_BELLY_FILTER_CLICKED,
  CMP_FILTER_CLICKED,
  CMP_PAGE_SHOWN,
  CMP_REVIEW_CANDIDATE_CLICKED,
  CMP_TAB_CLICKED,
  CONTACT_DETAILS_SAVE_DETAILS_CLICKED,
  DASHBOARD_JOB_SHARE_CLICKED,
  DASHBOARD_MENU_CLICKED,
  DASHBOARD_REFERRAL_CLICKED,
  DASHBOARD_WHATSAPP_CLICKED,
  DEACTIVATE_CONFIRM_LOGOUT,
  DOC_VERIFICATION_UPLOAD_SUCCESS,
  DOC_VERIFICATION_VERIFY_LATER_CLICKED,
  DV_BS_VERIFY_LATER_CLICKED,
  EDIT_JOB_CLICKED,
  EMAIL_VERIFY_RESENT_EMAIL_CLICKED,
  EMAIL_VERIFY_SUCCESS,
  EVENTS,
  FIRST_TIME_USER,
  GET_DOWNLOAD_APP_LINK,
  JOB_POST_EDIT,
  JOB_POST_OPENED,
  JOB_POST_SUCCESS,
  JOB_POST_SUCCESS_NEW_USER,
  MANUAL_JOB_CLOSE,
  MOENGAGE_USER,
  NPS_SUBMITTED,
  OWNER_EMPLOYEE_MAPPING_EVENTS,
  POST_PAGEONE_UPDATE_NEXT_CLICKED,
  RATE_US,
  RATING_BAD_CLICKED,
  RATING_CLOSED,
  RATING_GREAT_CLICKED,
  RATING_SATISFACTORY_CLICKED,
  REPOST_JOB_CLICKED,
  RESUME_INVITE_CLICKED,
  RETURNING_TIME_USER,
  SIGN_OUT,
  SIGN_OUT_ALL_DEVICE,
  USER_LOGIN_COMPLETE,
  VIEW_ALL_CANDIDATES,
  WHATSAPP_ENABLE_CLICKED
} from "./webengage/webEngageConstants";

const allowedEvents = {
  [ACTION_CANDIDATE_CALLED.name]: {},
  [CMP_PAGE_SHOWN.name]: { dependsOn: ["sessionId", "job_id"] },
  [ACTION_CANDIDATE_MESSAGED.name]: {},
  [ACTION_INVITE_FOR_INTERVIEW.name]: {},
  [VIEW_ALL_CANDIDATES.name]: {},
  [ACTION_CANDIDATE_REJECT.name]: {},
  [ACTION_OPEN_RESUME.name]: {},
  [JOB_POST_OPENED.name]: { dependsOn: ["sessionId"] },
  [CMP_TAB_CLICKED.name]: {},
  [DASHBOARD_MENU_CLICKED.name]: {},
  [JOB_POST_SUCCESS.name]: {},
  [CMP_FILTER_CLICKED.name]: {},
  [CMP_AUDIO_PLAYED.name]: {},
  [CLOSE_JOB_CLICKED.name]: {},
  [CALL_FEEDBACK_EVENTS.CALL_FEEDBACK_SUBMIT.name]: {},
  [MANUAL_JOB_CLOSE.name]: {},
  [CMP_AUDIO_COMPLETE.name]: {},
  [USER_LOGIN_COMPLETE.name]: {},
  [RETURNING_TIME_USER.name]: {},
  [EDIT_JOB_CLICKED.name]: {},
  //diff
  [JOB_POST_EDIT.name]: {},
  [DOC_VERIFICATION_VERIFY_LATER_CLICKED.name]: {},
  [CONTACT_DETAILS_SAVE_DETAILS_CLICKED.name]: {},
  [REPOST_JOB_CLICKED.name]: {},
  [DOC_VERIFICATION_UPLOAD_SUCCESS.name]: {},
  [RATING_CLOSED.name]: {},
  [FIRST_TIME_USER.name]: {},
  [DV_BS_VERIFY_LATER_CLICKED.name]: {},
  [POST_PAGEONE_UPDATE_NEXT_CLICKED.name]: {},
  [DASHBOARD_JOB_SHARE_CLICKED.name]: {},
  [JOB_POST_SUCCESS_NEW_USER.name]: {},
  [GET_DOWNLOAD_APP_LINK.name]: {},
  [RESUME_INVITE_CLICKED.name]: {},
  [SIGN_OUT.name]: {},
  //diff bleow
  [CMP_REVIEW_CANDIDATE_CLICKED.name]: {},
  [EMAIL_VERIFY_SUCCESS.name]: {},
  [CMP_BELLY_FILTER_CLICKED.name]: {},
  [CANDIDATE_FEEDBACK_SUBMIT.name]: {},
  [RATING_GREAT_CLICKED.name]: {},
  [RATING_SATISFACTORY_CLICKED.name]: {},
  [RATING_BAD_CLICKED.name]: {},
  [DASHBOARD_REFERRAL_CLICKED.name]: {},
  [SIGN_OUT_ALL_DEVICE.name]: {},
  [EVENTS.EMAIL_VERIFICATION.VERIFY_LATER_CTA.name]: {},
  [NPS_SUBMITTED.name]: {},
  [ACTION_DEACTIVATE.name]: {},
  [DEACTIVATE_CONFIRM_LOGOUT.name]: {},
  [WHATSAPP_ENABLE_CLICKED.name]: {},
  [DASHBOARD_WHATSAPP_CLICKED.name]: {},
  [RATE_US.name]: {},
  [EMAIL_VERIFY_RESENT_EMAIL_CLICKED.name]: {},
  [OWNER_EMPLOYEE_MAPPING_EVENTS.OWNER_EMPLOYEE_SUCCESSFUL_CONVERSION.name]: {},
  [CREDIT_EVENTS.PLAN_SELECTION_PAGE_LANDED.name]: {},
  [CREDIT_EVENTS.PLAN_SELECTION_BUY_CLICKED.name]: {},
  [CREDIT_EVENTS.CREDIT_SELECTION_CONTACT_SALES_CLICKED.name]: {},
  [CREDIT_EVENTS.BUY_CREDITS_CLICKED.name]: {},
  [CREDIT_EVENTS.SALES_POP_UP_SEND_CLICKED.name]: {},
  [CREDIT_EVENTS.CHECKOUT_PAGE_LANDED.name]: {},
  [CREDIT_EVENTS.CHECKOUT_PAY_CLICKED.name]: {},
  [CREDIT_EVENTS.TRANSACTION_STATUS_PAGE_LANDED.name]: {},
  [CREDIT_EVENTS.PAYMENT_FAILED_RETRY_CLICKED.name]: {},
  [CREDIT_EVENTS.JOB_PLAN_SELECTION_PAGE_LANDED.name]: {},
  [CREDIT_EVENTS.JOB_PLAN_CHANGED.name]: {},
  [CREDIT_EVENTS.JOB_PLAN_SELECTION_SAVE_JOB_CLICKED.name]: {},
  [CREDIT_EVENTS.JOB_PLAN_SELECTION_CONFIRM_POPUP_LANDED.name]: {},
  [CREDIT_EVENTS.JOB_PLAN_SELECTION_POPUP_CONFIRM_CLICKED.name]: {},
  [CREDIT_EVENTS.COHORT_LIMIT_INSUFF_CREDIT_LANDED.name]: {},
  [CREDIT_EVENTS.COHORT_IN_SUFF_BUY_CREDITS.name]: {},
  [CREDIT_EVENTS.DASHBOARD_UPGRADE_TO_PREMIUM_CLICK.name]: {},
  [CREDIT_EVENTS.UPGRADE_SUFFICIENT_CREDIT_LANDED.name]: {},
  [CREDIT_EVENTS.UPGRADE_SUFFI_CREDIT_LANDED_CONFIRM.name]: {},
  [CREDIT_EVENTS.UPGRADE_LIMIT_INSUFF_CREDIT_LANDED.name]: {},
  [CREDIT_EVENTS.UPGRADE_IN_SUFF_BUY_CREDITS.name]: {},
  [CREDIT_EVENTS.DASHBOARD_CREDIT_FIRST_TIME_LOGIN_GET_STARTED_CLICKED.name]:
    {},
  [CREDIT_EVENTS.COHORT_LIMIT_VIEW_CANDIDATES_CLICK.name]: {},
  [TEAM_DETAILS_EVENTS.ADD_MEMBER_POPUP_SUCCESS.name]: {},
  [TEAM_DETAILS_EVENTS.RESEND_INVITE_SUCCESS.name]: {},
  [TEAM_DETAILS_EVENTS.TEAMS_PAGE_SHOWN.name]: {},
  [TEAM_DETAILS_EVENTS.IR_ACCEPT_CLICKED.name]: {},
  [TEAM_DETAILS_EVENTS.IR_DECLINE_CLICKED.name]: {},
  [TEAM_JOINING_EVENTS.NOT_INTERESTED_CLICKED.name]: {}
};

class MoengageService {
  constructor() {
    const available = typeof window.Moengage !== "undefined";
    this.moengage = undefined;
    if (available) {
      this.moengage = window.Moengage;
    }
  }

  setProfileAttribute(attr, value) {
    if (this.moengage && value !== undefined && value !== null) {
      switch (attr) {
        case ProfileAttr.FIRST_NAME:
          this.moengage.add_first_name(value);
          break;
        case ProfileAttr.LAST_NAME:
          this.moengage.add_last_name(value);
          break;
        case ProfileAttr.EMAIL_ADDRESS:
          this.moengage.add_email(value);
          break;
        case ProfileAttr.PHONE:
          this.moengage.add_mobile(value);
          break;
        case ProfileAttr.FULL_NAME:
          this.moengage.add_user_name(value); // Full name for user
          break;
        case "gender":
          this.moengage.add_gender(value);
          break;
        case "birthday":
          this.moengage.add_birthday(new Date(1980, 2, 31));
          break;
      }
    }
  }

  setCustomAttributes({ name, value }) {
    if (this.moengage && name && value !== null && value !== undefined) {
      this.moengage.add_user_attribute(name, value);
      const saveLaterAttributes = StorageService.getFromLocalStorage(
        "save_later_attributes_rec"
      );
      if (saveLaterAttributes && Object.keys(saveLaterAttributes).length) {
        for (const key in saveLaterAttributes) {
          const saveLaterValue = saveLaterAttributes[key];
          if (key === "login") {
            ClmGetTrackingService().login(saveLaterValue);
          }
        }
        StorageService.removeFromLocalStorage("save_later_attributes_rec");
      }
    }
  }

  login(userId) {
    if (this.moengage) {
      if (userId) this.moengage.add_unique_user_id(userId);
    } else {
      const saveLaterAttributes =
        StorageService.getFromLocalStorage("save_later_attributes_rec") || {};
      if (process.browser) {
        saveLaterAttributes["login"] = userId;
        StorageService.setInLocalStorage(
          "save_later_attributes_rec",
          saveLaterAttributes
        );
      }
    }
  }

  logout() {
    if (this.moengage) {
      this.moengage.destroy_session();
    }
  }

  track({ eventName, value }) {
    const allowed = allowedEvents[eventName];

    const eventTrackingData =
      StorageService.getFromStorage(STORAGE_ITEMS.EVENT_TRACKING_DATA_REC) ||
      {};

    if (allowed) {
      if (Object.keys(allowed).includes("dependsOn")) {
        const { dependsOn } = allowed;
        const hashableItems = [];
        if (dependsOn.includes("sessionId")) {
          hashableItems.push(StorageService.getSessionId());
          hashableItems.push(eventName);
        }
        if (dependsOn.includes("job_id") && value?.job_id) {
          hashableItems.push(value.job_id);
        }
        const hash = createHash(hashableItems.join());
        if (eventTrackingData[hash] === eventName) return;

        eventTrackingData[hash] = eventName;
        StorageService.setInStorage(
          STORAGE_ITEMS.EVENT_TRACKING_DATA_REC,
          eventTrackingData
        );
      }

      if (this.moengage) {
        if (!value && eventName) {
          this.moengage.track_event(eventName);
        } // This event has no attributes
        if (eventName && value !== null && value !== undefined) {
          this.moengage.track_event(eventName, value);
        }
      }
    }
  }

  trackData(data) {
    if (data) {
      const {
        first_name,
        last_name,
        fullName,
        phone,
        email,
        company,
        is_whatsapp_enabled,
        is_sms_enabled,
        designation,
        hiring_in,
        recruiter_id
      } = data;
      const moengageEvent = StorageService.getFromLocalStorage(
        "MOENGAGE_LOGIN_EVENT_REC"
      );
      if (!moengageEvent) {
        LogService.log(MOENGAGE_USER, { userId: recruiter_id });
        StorageService.setInLocalStorage("MOENGAGE_LOGIN_EVENT_REC", true);
        this.login(recruiter_id);
      }
      this.setProfileAttribute(ProfileAttr.FIRST_NAME, first_name);
      this.setProfileAttribute(ProfileAttr.LAST_NAME, last_name);
      this.setProfileAttribute(ProfileAttr.FULL_NAME, fullName);
      this.setProfileAttribute(ProfileAttr.PHONE, phone);
      this.setProfileAttribute(ProfileAttr.EMAIL_ADDRESS, email);
      this.setCustomAttributes({
        name: "JHR Company City",
        value: company?.city
      });
      this.setCustomAttributes({
        name: "JHR Whatsapp Status",
        value: is_whatsapp_enabled
      });
      this.setCustomAttributes({
        name: "JHR SMS Status",
        value: is_sms_enabled
      });
      this.setCustomAttributes({
        name: "moe_sms_subscription",
        value: is_sms_enabled
      });

      this.setCustomAttributes({
        name: "moe_wa_subscription",
        value: is_whatsapp_enabled
      });

      this.setCustomAttributes({
        name: "JHR Designation",
        value: designation
      });
      this.setCustomAttributes({
        name: "JHR Hiring In",
        value: hiring_in
      });
      this.setCustomAttributes({
        name: "JHR Company Name",
        value: company?.name
      });
    }
  }
}

const ClmGetTrackingService = () => {
  return new MoengageService();
};
export default ClmGetTrackingService;

function createHash(concatenatedInputs) {
  let hash = 0;

  for (let i = 0; i < concatenatedInputs.length; i++) {
    const charCode = concatenatedInputs.charCodeAt(i);
    hash = (hash << 5) - hash + charCode;
    hash |= 0; // Convert to 32-bit integer
  }

  return hash.toString(16); // Return the hash as a hexadecimal string
}
